export default __webpack_public_path__ + "static/media/employer-form.404ccf67.svg";